var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSnFbAtfnydiyc3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_2",
    "data-name": "\\u5716\\u5C64 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#050505;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 24,
    height: 24,
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.56,14.77V12.14c0-.14,0-.14-.14-.14H9.51c-.08,0-.11,0-.11-.11v-1.7c0-.08,0-.1.11-.1h.94c.08,0,.11,0,.11-.11,0-.47,0-.94,0-1.41a2.75,2.75,0,0,1,.3-1.13,1.85,1.85,0,0,1,1.32-.91,4.21,4.21,0,0,1,.87-.08h1.4c.11,0,.12,0,.12.12V8.24c0,.11,0,.11-.13.11h-.93l-.23,0a.45.45,0,0,0-.4.46c0,.34,0,.68,0,1s0,.23.24.23H14.5c.1,0,.11,0,.1.11-.06.57-.13,1.13-.18,1.7,0,.08,0,.1-.12.1H13c-.12,0-.12,0-.12.12v5.3c0,.13,0,.14-.13.14H10.68c-.12,0-.12,0-.12-.13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSnFbAtfnydiyc3);
export default __webpack_public_path__ + "static/media/sn-fb-atfnydiyc3.72ac0348c397350f05e3c4696c4c70b1.svg";
export { ForwardRef as ReactComponent };